import React from 'react'
import PropTypes from 'prop-types'

import AddButton from './AddButton'
import CommunityList from './CommunityList'
import CommunityFormDialog from './CommunityFormDialog'

class CommunityAdmin extends React.Component {
  static propTypes = {
    communities: PropTypes.object.isRequired,
    onCreateCommunity: PropTypes.func.isRequired,
    onUpdateCommunity: PropTypes.func.isRequired,
  }

  state = {
    isDialogOpen: false,
    community: {},
    onSubmit: () => {},
  }

  handleAdd = () => {
    this.setState({
      community: {},
      onSubmit: this.props.onCreateCommunity,
      isDialogOpen: true,
    })
  }

  handleEdit = (community) => {
    this.setState({
      community,
      onSubmit: this.props.onUpdateCommunity,
      isDialogOpen: true,
    })
  }

  onDialogClose = () => {
    this.setState({
      onSubmit: () => {},
      isDialogOpen: false,
      community: {},
    })
  }

  render() {
    return (
      <div>
        <AddButton label="Add Community" onClick={this.handleAdd} />
        <CommunityList communities={this.props.communities} onEdit={this.handleEdit} />

        {this.state.isDialogOpen && (
          <CommunityFormDialog
            community={this.state.community}
            onClose={this.onDialogClose}
            onSubmit={this.state.onSubmit}
          />
        )}
      </div>
    )
  }
}

export default CommunityAdmin
